import styled from 'styled-components';

export const Container = styled.div<{
  $margin: string;
}>`
  margin: ${({ $margin }) => $margin};
`;

const Value = styled.p`
  font-size: 10px;
  line-height: 14px;
  margin: 0;
`;

export const ValueHighlighted = styled(Value)`
  font-weight: bold;
  font-size: 11px;
  line-height: 20px;
  margin: 0;
  flex: 1;
`;

export const Description = styled(Value)`
  font-size: 11px;
  line-height: 20px;
`;

export const Date = styled.div`
  font-size: 8px;
  line-height: 11px;
  margin: 0;
  color: var(--mainColor);
`;
